/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import _ from "lodash";
// import axios from '../../../api/axiosService';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import axios from "../../../api/axiosService";
import dayjs from "dayjs";
import { sanitize } from "../../../Common/Util";

export default function Fanclub({ id }) {
  const { i18n } = useTranslation();
  const [data, setData] = useState({});
  const [projects, setProject] = useState([]);
  const [news, setNew] = useState([]);

  useEffect(() => {
    if (!id) return;

    let cancelled = false;

    const loadData = async () => {
      try {
        const [fc, projectsRes, newsRes] = await Promise.all([
          axios.get(`/api/fanClub/info?artistId=${id}`),
          axios.get(`/api/projectFanClub/list?artistId=${id}`),
          axios.get(`/api/news/list?artistId=${id}`),
        ]);

        if (cancelled) return;

        setData(fc.data.data);
        setProject(projectsRes.data.data);
        setNew(newsRes.data.data);
      } catch (error) {
        if (!cancelled) {
          console.error("Error fetching data: ", error);
        }
      }
    };

    loadData();

    return () => {
      cancelled = true;
    };
  }, [id]);

  useEffect(() => {
    const el = desRef.current;
    if (el) {
      // So sánh scrollHeight và clientHeight để xem có bị cắt không
      setShowButton(el.scrollHeight > el.clientHeight);
    }
  }, [data.des]);

  const [isFullDes, setFullDes] = useState(false);
  const handleFullDes = () => {
    setFullDes(!isFullDes);
  };
  const [showButton, setShowButton] = useState(false);
  const desRef = useRef(null);
  const logo = _.get(data, "logo", "");

  return (
    <div className="fanclub-tab">
      {_.isObject(data) && (
        <div className="content">
          {logo && (
            <div className="fc-info">
              <img className="logo" src={logo} alt="" />
              <div className="description text-justify">
                <div
                  ref={desRef}
                  className={
                    isFullDes ? "text-full normal-text" : "text normal-text"
                  }
                  dangerouslySetInnerHTML={sanitize(data.des)}
                />
              </div>
            </div>
          )}          <div className="fc-project">
            <div className="title title-2">fc project</div>
            <hr className="hr-project" />
            {projects?.length > 0 && (
              <Swiper
                modules={[Navigation]}
                navigation
                loop={projects?.length > 1}
                slidesPerView={1}
                spaceBetween={0}
                className="w-full h-auto swiper-artirst-fanclub"
                style={{ maxWidth: "1280px", maxHeight: "720px" }}
              >
                {projects?.length > 0 &&
                  projects.map((value, index) => (
                    <SwiperSlide key={index} className="slider">
                      <img
                        src={_.get(value, "image", "")}
                        alt={_.get(value, "image")}
                        className="post-img object-cover"
                      />
                      <div className="name normal-text">{value.name}</div>
                    </SwiperSlide>
                  ))}
              </Swiper>
            )}
          </div>
          <div className="fc-news">
            <div className="title title-2">fc news</div>
            <hr className="hr-news" />
            <div className="news mb-[50px]">
              {news?.length > 0 &&
                news.map((data, index) => (
                  <a
                    href={data.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block mb-[20px] fc-news"
                  >
                    <div key={index} className="mb-[20px] flex justify-center">
                      <div className="w-[80%] md:w-full border border-transparent hover:border-teal-500 hover:text-teal-500 md:p-4 flex flex-col h-full relative">
                        <div className="pb-8 md:pb-16">
                          <div className="aspect-square w-full md:w-[22vw] md:h-[20.5vw] overflow-hidden">
                            <img
                              src={data.image}
                              alt={
                                i18n.language?.startsWith("vi")
                                  ? data.title_VN
                                  : data.title_ENG || data.title_VN
                              }
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <h3 className="text-md md:text-xl font-bold leading-[150%] max-w-full md:max-w-[22vw] min-h-[30px] md:min-h-[60px] line-clamp-2 overflow-hidden font-semibold line-clamp-3 overflow-hidden uppercase mt-[5px] md:mt-[30px]">
                            {i18n.language?.startsWith("vi")
                              ? data.title_VN
                              : data.title_ENG || data.title_VN}
                          </h3>
                        </div>
                        <p className="article-date text-gray-500 absolute bottom-0 left-0 md:bottom-4 md:left-4">
                          {dayjs(data.createdAt).format("DD/MM/YYYY")}
                        </p>
                      </div>
                    </div>
                  </a>
                ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const DATA = {
  id: "61ab39bdd4607e001d53bd2f",
  name: "Kingdom",
  des: "KINGDOM là tên gọi đầy tự hào của cộng đồng fan hâm mộ nghệ sĩ SOOBIN. Với ý nghĩa tượng trưng cho một vương quốc hùng mạnh, nơi các fan cùng nhau chung sống, KINGDOM là tên gọi đầy tự hào của cộng đồng fan hâm mộ nghệ sĩ SOOBIN. Với ý nghĩa tượng trưng cho một vương quốc hùng mạnh, nơi các fan cùng nhau chung sống, KINGDOM là tên gọi đầy tự hào của cộng đồng fan hâm mộ nghệ sĩ SOOBIN. Với ý nghĩa tượng trưng cho một vương quốc hùng mạnh, nơi các fan cùng nhau chung sống,",
  project: [
    {
      name: "SOOBIN FAN MEETING HA NOI",
      image:
        "https://spacespeaker.s3.ap-southeast-1.amazonaws.com/uploads/soobin-1-jpg-1741219596-174121-3885-6851-1741219842-1742545823219.webp",
    },
    {
      name: "SOOBIN FAN MEETING HA NOI",
      image:
        "https://spacespeaker.s3.ap-southeast-1.amazonaws.com/uploads/soobin-1-jpg-1741219596-174121-3885-6851-1741219842-1742545823219.webp",
    },
    {
      name: "SOOBIN FAN MEETING HA NOI",
      image:
        "https://spacespeaker.s3.ap-southeast-1.amazonaws.com/uploads/soobin-1-jpg-1741219596-174121-3885-6851-1741219842-1742545823219.webp",
    },
    {
      name: "SOOBIN FAN MEETING HA NOI",
      image:
        "https://spacespeaker.s3.ap-southeast-1.amazonaws.com/uploads/soobin-1-jpg-1741219596-174121-3885-6851-1741219842-1742545823219.webp",
    },
  ],
  news: [
    {
      id: 1,
      image:
        "https://spacespeaker.s3.ap-southeast-1.amazonaws.com/uploads/soobin-1-jpg-1741219596-174121-3885-6851-1741219842-1742545823219.webp",
      name: "Soobin thắng lớn ở giải Cống Hiến",
      date: "6/3/2025",
    },
    {
      id: 2,
      image:
        "https://spacespeaker.s3.ap-southeast-1.amazonaws.com/uploads/473176314101621318568295472885725680934800306n-1736841987390179740430-1736849399785-17368494010351208394103-1742546316735.webp",
      name: '1 thập kỷ càn quét WeChoice Awards của "hoàng tử" SOOBIN 1 thập kỷ càn quét WeChoice Awards ',
      date: "14/01/2025",
    },
    {
      id: 3,
      image:
        "https://spacespeaker.s3.ap-southeast-1.amazonaws.com/uploads/ap3i6776-1835-6101-1742548553956.jpg",
      name: `KRISS NGÔ: TỮ HỌC BÁ CHUYÊN ANH ĐỂN "PRODUCER CỦA NĂM"`,
      date: "14/01/2025",
    },
  ],
};
